module.exports = __webpack_public_path__ + "img/aq.114a756d.svg";